import { render } from "./PathwaysQuestionLowerUsage.vue?vue&type=template&id=108d46b9"
import script from "./PathwaysQuestionLowerUsage.vue?vue&type=script&lang=js"
export * from "./PathwaysQuestionLowerUsage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__